<template>
  <Modal :id="'cmp-distribution-orders-add-orderlines'" @cancelled="onCancel">
    <template slot="header"> {{ orderLineModalTitle }} </template>

    <template slot="body">
      <div class="contact-search" style="margin-left: 5px">
        <div class="search" style="margin-top: -5px">
          <TextField
            class="m1"
            :id="'str'"
            v-bind="textFieldConfig"
            :value="filter.str"
            :placeholder="$t('search')"
            @valuechanged="onTextFieldValueChange"
            :disabled="searchDataLoading"
          ></TextField>
        </div>
        <div class="search" style="margin-top: -5px">
          <TextField
            class="m1"
            :id="'artist'"
            v-bind="textFieldConfig"
            :value="filter.artist"
            :placeholder="$t('artist')"
            @valuechanged="onTextFieldValueChange"
            :disabled="searchDataLoading"
          ></TextField>
        </div>
        <div class="search">
          <Dropdown
            :options="labelTV"
            :placeholder="$t('label')"
            box
            deselect
            :selected="labelTV.find((e) => e.value == filter.label_id)"
            v-on:selectedChange="(e) => onDropdownChange('label_id', e)"
            :listHeight="240"
            :disabled="searchDataLoading"
          >
          </Dropdown>
        </div>
        <div class="search">
          <Dropdown
            :options="productTypeTV"
            :placeholder="$t('category')"
            box
            deselect
            :selected="
              productTypeTV.find((e) => e.value == filter.product_type_id)
            "
            v-on:selectedChange="(e) => onDropdownChange('product_type_id', e)"
            :listHeight="240"
            :disabled="searchDataLoading"
          >
          </Dropdown>
        </div>
      </div>

      <div
        class="cm-order-list-container hoverFC2"
        style="margin-top: 24px; height: 300px"
      >
        <NTable
          class="dbox1"
          id="distribution-order-orderline-modal"
          :config="tableConfig"
          :headers="headers"
          :items="list"
          @scrollnext="onOrderTableScrollNext"
        >
          <template v-slot:thead="{ thcon }">
            <tr style="color: var(--text-5)">
              <th v-bind="thcon('catalog_no')">
                <div class="ut-fc">
                  <!-- <span> {{ $t("catalog_no") }}. </span> -->
                  <span>{{ $t("catalog_no") + "." }}</span>
                  <span>{{ $t("barcode") }}</span>
                </div>
              </th>
              <th v-bind="thcon('label')">
                <div class="ut-fc">
                  <span>{{ $t("label") }}</span>
                  <span>{{ $t("Format") }}</span>
                </div>
              </th>
              <th v-bind="thcon('artist')">
                <div class="ut-fc">
                  <span>{{ $t("artist") }}</span>
                  <span>{{ $t("ps_title") }}</span>
                </div>
              </th>
              <th v-bind="thcon('order_price')">
                <span style="text-align: right">{{ orderCurrency }}</span>
              </th>
              <th v-bind="thcon('product_stock')">
                <div style="white-space: nowrap !important">
                  {{ $t("available_qty") }}
                </div>
              </th>
              <th v-bind="thcon('order_qty')">
                <span> {{ $t("order_qty") }} </span>
              </th>
              <th v-bind="thcon('promo')">
                <span> {{ $t("promo") }} </span>
              </th>
              <th v-bind="thcon('foc')">
                <span> {{ $t("foc") }} </span>
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item, tdcon }">
            <tr
              :class="{
                selected: selectedRow(item),
              }"
              @click="onRowClicked(item)"
            >
              <td v-bind="tdcon('catalog_no')">
                <div class="ut-flex">
                  <div class="circular-status">
                    <div
                      class="circular-status-color"
                      style="
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        margin-right: 8px;
                      "
                      :style="{
                        'background-color': `#${item['label_status_colour']}`,
                        border: item['label_status_colour']
                          ? `1px solid #${item['label_status_colour']}`
                          : '1px solid gray',
                      }"
                    ></div>
                  </div>

                  <div class="ut-fc ut-txtov">
                    <span class="ut-txtov" :title="item['catalog_no']">{{
                      item["catalog_no"]
                    }}</span>
                    <span class="ut-txtov" :title="item['barcode']">{{
                      item["barcode"]
                    }}</span>
                  </div>
                </div>
              </td>
              <td v-bind="tdcon('label')">
                <div class="ut-fc ut-txtov">
                  <span class="ut-txtov" :title="item['label_name']">{{
                    item["label_name"]
                  }}</span>
                  <span class="ut-txtov" :title="item['format_name']">{{
                    item["format_name"]
                  }}</span>
                </div>
              </td>
              <td v-bind="tdcon('artist')">
                <div class="ut-fc ut-txtov">
                  <span class="ut-txtov" :title="item['release_alt_artist']">{{
                    item["release_alt_artist"]
                  }}</span>
                  <span class="ut-txtov" :title="item['release_alt_title']">{{
                    item["release_alt_title"]
                  }}</span>
                </div>
              </td>
              <td v-bind="tdcon('order_price')">
                <span>{{ item["order_price"] }}</span>
              </td>
              <td v-bind="tdcon('product_stock')">
                <span>{{ stocks[item["product_id"]] }}</span>
              </td>
              <td v-bind="tdcon('order_qty')">
                <TextField2
                  type="number"
                  class="dbox1"
                  id="order_qty"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['order_qty']"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('promo')">
                <TextField2
                  type="number"
                  class="dbox1"
                  id="promo_qty"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['promo_qty']"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('foc')">
                <TextField2
                  type="number"
                  class="dbox1"
                  id="foc_qty"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['foc_qty']"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </template>

    <template slot="options">
      <button
        class="dt-button with-ico s6"
        :disabled="!stockShowable"
        :title="
          list.length == 0
            ? 'Select Product List First'
            : this.loadedStock == this.productIds
            ? 'Stock already Loaded'
            : 'Click to see stock of Products'
        "
        :class="{ disabled: !stockShowable }"
        @click="onShowStockClick"
      >
        <div v-if="this.loadedStock != this.productIds">
          {{ $t("show_stock") }}
        </div>
        <div v-if="this.loadedStock == this.productIds">
          {{ $t("stock") }} {{ $t("loaded") }}
        </div>
      </button>
      <button
        class="dt-button v1 with-ico s6"
        :disabled="addOrderLock || addableOrders.length === 0"
        :class="{ disabled: addOrderLock || addableOrders.length === 0 }"
        @click="onAddOrderLineClicked"
      >
        <div class="button-text">{{ $t('add_to_order') }}</div>
      </button>

      <button class="dt-button s6" @click="onCancel">{{$t('done')}}</button>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as orderActionTypes from "../../store/orders/types";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@/plugins/text-field/input-field";
import Checkbox2 from "@/plugins/checkbox/checkbox-2";
import { waitForAnimation, subscribeSubject } from "../../../../utility";
import Modal from "@/dt-plugins/modal/modal";
import {
  createModalMixin,
  closeModal2Route,
  openModal2Route,
} from "@/dt-plugins/modal/modal.mixin";
import { async } from "rxjs/internal/scheduler/async";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "@/plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import { OrderService } from "../../services/order.service";
import { createTV } from "../../../../models/text-value.model";
import { filter } from "ramda";
export default {
  components: {
    InputField,
    Checkbox2,
    Modal,
    NTable,
  },

  mixins: [],
  watch: {},
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 2,
        scrollNextThreshold: 95,
        fullHeight: true,
        headerHeight: 52,
        rowHeight: 52,
      }),

      selectedMultiOrder: {
        order_ids: [],
        account_date: "",
        set_paid: 1,
        payment_date: "",
        money_account: "",
      },
      filter: {
        str: "",
        product_type_id: null,
        label_id: null,
        artist: "",
        show_stock: "0",
      },

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },

      labelList: [],
      productTypeList: [],
      productsToSubmit: [],
      searchList: [],

      accountDetails: null,

      searchSubject: new Subject(),

      addOrderLock: false,

      stocks: {},

      searchDataLoading: false,

      showStockLoading: false,
      loadedStock: "Init",
    };

    //MARK: Data
  },
  mounted: async function () {
    this.searchDataLoading = true;
    const resData = await OrderService.getOrderlineFromData(
      this.$route.params.order_id
    );
    this.labelList = resData.data.labels;
    this.productTypeList = resData.data.product_types;
    console.log("MOUNTED DATA:", resData);

    this.accountDetails = await OrderService.order_details_tab_packing_shipping(
      this.$route.params.order_id
    );

    this.searchDataLoading = false;

    subscribeSubject(this, this.searchSubject, (str) => {
      this.fetchSearchResult();
    });
  },

  computed: {
    list: function () {
      return this.searchList.length > 0 ? this.searchList : [];
    },
    labelTV: function () {
      return createTV(this.labelList, "label_name", "label_id");
    },
    productTypeTV: function () {
      return createTV(
        this.productTypeList,
        "product_type_name",
        "product_type_id"
      );
    },
    hRowMarginRight: function () {
      if (this.orders.length > 380 / 28) {
        return "28px";
      }
    },
    headers: function () {
      return [
        createTableHeader("catalog_no", { text: false }),
        createTableHeader("label", {}),
        createTableHeader("artist", { text: this.$t("title") }),
        createTableHeader("order_price", { ta: "right", mw: 70 }),
        createTableHeader("product_stock", { ta: "right", mw: 100 }),
        createTableHeader("order_qty", { mw: 80 }),
        createTableHeader("promo", { mw: 70 }),
        createTableHeader("foc", { mw: 70 }),
      ];
    },
    tableHeight: function () {
      return this.list.length * 28;
    },
    orderLineModalTitle() {
      const order = this.accountDetails?.data?.order;
      const account = this.accountDetails?.data?.account;

      const order_type_name = order?.order_type_name;
      const order_id = order?.order_id;
      const price_list_name = order?.price_list_name;
      const account_name = account?.account_name;

      console.log({ "add-orderlines-modal.vue:283 order": order, account });

      // if (order_type_name) {
      //   str += order_type_name;
      // }
      // if (str) {
      //   str += " #" + order_id;
      // } else {
      //   str += "#" + order_id;
      // }
      // if (account_name) {
      //   str += " | " + account_name;
      // }
      // if (price_list_name) {
      //   str += " | " + price_list_name;
      // }

      //Conditionally append data and separator if exists
      return (
        `${order_type_name ? `${order_type_name} ` : ""}${
          order_id ? `#${order_id}` : ""
        }${account_name ? ` | ${account_name}` : ""}${
          price_list_name ? ` | ${price_list_name}` : ""
        }` || "Add Order Line"
      );
      // return `Modal Title`;
    },

    addableOrders() {
      return this.list?.filter((e) => {
        // Either of these order_qty || promo_qty || foc_qty || order_price
        return (
          +e.order_qty > 0 ||
          +e.promo_qty > 0 ||
          +e.foc_qty > 0 ||
          +e.order_price > 0
        );
      });
    },
    productIds() {
      return this.list?.map((e) => e.product_id).join(",");
    },
    stockShowable() {
      return (
        this.list?.length > 0 &&
        !this.showStockLoading &&
        this.loadedStock != this.productIds
      );
    },
    orderCurrency() {
      return (
        this.accountDetails?.order?.currency_iso ||
        this.$store.getters.account.client.default_currency ||
        "EUR"
      );
    },
  },
  methods: {
    onTextFieldChange: function (e, item) {
      const { name, value } = e;

      console.log(":::::", this.list);
      const product = this.productsToSubmit.find(
        (e) => e.product_id == item.product_id
      );

      if (!product) {
        this.productsToSubmit = [
          {
            product_id: item.product_id,
            order_price: item.order_price,
            order_qty: 0,
            promo_qty: 0,
            foc_qty: 0,
          },
        ];
      }

      this.productsToSubmit = this.productsToSubmit.map((e) => {
        if (e.product_id == item.product_id) {
          return {
            ...e,
            [name]: value,
          };
        } else {
          return e;
        }
      });

      this.searchList = this.searchList.map((e) => {
        if (e.product_id == item.product_id) {
          return {
            ...e,
            [name]: parseFloat(value),
          };
        } else {
          return e;
        }
      });
    },
    getQtyValue: function (item, name) {
      const product = this.productsToSubmit.find(
        (e) => e.product_id == item.product_id
      );
      if (product && product[name] != 0) {
        console.log("PRODUCT:::", product[name]);
        return product[name];
      }
    },
    onAddOrderLineClicked: async function () {
      console.log(this.productsToSubmit);
      if (this.addOrderLock) {
        return;
      } else {
        this.addOrderLock = true;
      }
      // const pList = this.list.map((e) => {
      //   if (!this.productsToSubmit.find((x) => x.product_id == e.product_id)) {
      //     return {
      //       product_id: e.product_id,
      //       order_price: e.order_price,
      //       order_qty: 0,
      //       promo_qty: 0,
      //       foc_qty: 0,
      //     };
      //   }
      // });

      //this.productsToSubmit=this.

      const insertedOrderline = await OrderService.addProdctsToOrder({
        order_id: this.$route.params.order_id,
        products: this.addableOrders,
      });

      this.$emit("added", {
        order_id: this.$route.params.order_id,
        // products: [...pList, ...this.productsToSubmit],
      });
      await this.resetSearchFilters();
      this.addOrderLock = false;
      // this.$emit("cancelled", true);
    },

    async resetSearchFilters() {
      this.filter = {
        ...this.filter,
        product_type_id: "",
        label_id: "",
        artist: "",
        str: "",
      };
      await this.fetchSearchResult();
    },
    selectedRow: function (order) {
      return (
        this.selectedClickedOrder &&
        this.selectedClickedOrder["order_id"] === order["order_id"]
      );
    },
    onRowClicked: function (order) {},
    fetchSearchResult: async function () {
      const resData = await OrderService.getFilteredOrderProducts({
        order_id: this.$route.params.order_id,
        ...this.filter,
        label_id: this.filter.label_id || "",
        product_type_id: this.filter.product_type_id || "",
      });
      this.searchList = resData.data.products;
      console.log("filter", this.filter);
    },
    onTextFieldValueChange: function (name, value) {
      this.filter[name] = value;
      this.searchSubject.next(value);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange(name, e) {
      this.filter[name] = e.value;
      this.fetchSearchResult();
      console.log(e, name);
    },

    onOrderTableScrollNext: function (percent) {},
    async onShowStockClick() {
      this.showStockLoading = true;
      const stocksRes = await OrderService.productAvailableStock({
        order_id: this.$route.params.order_id,
        product_ids: this.list?.map((e) => e.product_id),
      });
      this.showStockLoading = false;
      this.loadedStock = this.productIds;
      this.stocks = stocksRes.data?.stocks;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-orders-add-orderlines {
  table.dt-ntable {
    thead {
      background: wheat !important;
    }
    tr {
      th {
        white-space: pre !important;
      }
    }
  }
}

.contact-search {
  height: 30px;
  width: 100%;
  .search {
    margin-right: 10px;
    width: 250px;
  }
  .users-dropdown {
    width: 250px;
  }
}

.cm-order-list-container {
  // .order-list {
  //   --ntable-height: 300px !important;
  //   --tb-layout: fixed;
  //   tr {
  //     padding-left: 5px;
  //   }
  //   td:last-child,
  //   th:last-child {
  //     width: 50px !important;
  //   }

  //   td.name {
  //     color: black !important;
  //     font-weight: 800 !important;
  //   }
  // }

  // .dt-table.ind-table {
  //   td:nth-child(5),
  //   th:nth-child(5) {
  //     width: 50px !important;
  //   }
  // }
}
.contact-search {
  display: flex;
  margin: 20px;
  // flex-direction: row;
  // justify-content: stretch;
}
.fc2-checkbox {
  .dt-checkbox-container {
    .dt-checkbox {
      margin-top: 12px !important;
    }
  }
}

// button {
//   height: 2.5em;
//   border: 1px solid #ccc;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s ease;
//   border-radius: 5px;
// }
</style>
